import { ApiStatus } from '@/business-components/api-status/ApiStatus';
import type { ApiStatusType } from '@tarslib/types/lib/httpApi';
import clsx from 'clsx';

export type ResourceHeaderProps = {
  status?: ApiStatusType;
  suffix?: React.ReactNode;
  name: string;
  className?: string;
  suffixClassName?: string;
};

export function ResourceHeader(props: ResourceHeaderProps) {
  const { status, className, name, suffix, suffixClassName } = props;

  return (
    <div className={clsx('flex items-start justify-between gap-2', className)}>
      <div className="flex w-0 flex-1 gap-2">
        <h1 className="text-[32px] font-600 leading-10 text-color" title={name}>
          {name}
        </h1>

        {status && (
          <div className="flex h-10 flex-shrink-0 items-center">
            <ApiStatus status={status} />
          </div>
        )}
      </div>

      {suffix && (
        <div className={clsx('flex h-10 flex-shrink-0 items-center', suffixClassName)}>
          {suffix}
        </div>
      )}
    </div>
  );
}
